module.exports = __webpack_public_path__ + "static/DSC_9507-83833b78441d704d467f08d9c8d54715.jpg";